import { Skeleton } from "antd"
import React from "react"

export const SkeletonSmall = () => <Skeleton title={false} paragraph={{ rows: 1, width: 50 }} round={true} />
export const SkeletonMedium = () => <Skeleton title={false} paragraph={{ rows: 1, width: 100 }} round={true} />
export const SkeletionLarge = () => <Skeleton title={true} paragraph={false} round={true} />
